import React from 'react';
import Button from 'apollo-react/components/Button';
import styles from './ApproveButton.module.css';
import { isReviewerActionableStatus } from '../../../../constants/statuses';

const ApproveButton = ({
  onApprove,
  onUndo,
  isApproving,
  isDeleting,
  isApproved,
  requestProgress,
  children,
}) => {
  if (!(
    isReviewerActionableStatus(requestProgress?.status) && children?.length
  )) {
    return null;
  }

  const getButtonText = () => {
    if (isApproving) {
      return 'Approving...';
    }
    if (isDeleting) {
      return 'Undoing...';
    }
    if (isApproved) {
      return 'Undo Section Approval';
    }
    return 'Approve Section';
  };

  const getButtonVariant = () => {
    return isApproved ? 'secondary' : 'primary';
  };

  const handleClick = () => {
    if (isApproved && onUndo) {
      onUndo();
    } else if (!isApproved && onApprove) {
      onApprove();
    }
  };

  const isDisabled = isApproving || isDeleting;

  return (
    <Button
      variant={getButtonVariant()}
      className={styles.approveSectionButton}
      onClick={handleClick}
      disabled={isDisabled}
    >
      {getButtonText()}
    </Button>
  );
};

export default ApproveButton;
